import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';

// Redirige los enlaces antiguos /ess/... a la misma ruta sin /ess (conserva parámetros)
@Injectable({
    providedIn: 'root'
})
export class EssRedirectGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): UrlTree {
        const nuevaUrl = state.url.replace(/^\/ess(?=\/|\?|$)/, '') || '/';
        return this.router.parseUrl(nuevaUrl);
    }
}
